import { render, staticRenderFns } from "./dentaldet.vue?vue&type=template&id=100cc8f3&scoped=true"
import script from "./dentaldet.vue?vue&type=script&lang=js"
export * from "./dentaldet.vue?vue&type=script&lang=js"
import style0 from "./dentaldet.vue?vue&type=style&index=0&id=100cc8f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100cc8f3",
  null
  
)

export default component.exports